import { MeetingsScheduleSlotInterface } from "@api/models/interfaces/meetings-schedule/MeetingsScheduleSlotInterface";
import { DateTime } from "luxon";

export class MScheduleSlot implements MeetingsScheduleSlotInterface {

    id?: string;
    scheduleId: string;
    ownerIds?: number[] | null;
    beginAt: DateTime | string;
    endAt: DateTime | string;
    isNotAvailable?: boolean;

    private static dates: string[] = ['beginAt', 'endAt'];

    constructor(source: MeetingsScheduleSlotInterface) {

        this.id = source.id;
        this.scheduleId = source.scheduleId || "";
        this.ownerIds = source.ownerIds;
        this.beginAt = DateTime.fromISO(source.beginAt as string);
        this.endAt = DateTime.fromISO(source.endAt as string);
        this.isNotAvailable = source.isNotAvailable;

    }

    get ownerId() {
        return this.ownerIds?.length ? this.ownerIds[0] : null;
    }

    set ownerId(userId: number | null) {
        this.ownerIds = userId ? [userId] : null
    }
}